import * as Yup from 'yup'

/** Checks for valid SSN format and validates if it already exists on the application */
export const socialSecurityNumberValidation = (
  ssnUnmaskedCleaned: string,
  applicationSsns: any,
  applicationState: string
) =>
  // SSN is optional when marital status is not null and application state is pending-app-submit or pending-qualification
  Yup.string().when('marital_status', {
    is: (maritalStatus: string) =>
      maritalStatus !== null &&
      ['pending-qualification', 'pending-app-submit'].includes(applicationState),
    then: Yup.string(),
    otherwise: Yup.string()
      .required('SSN is required')
      .matches(/^(\d{9}|\*+\d{4})$/, 'Please enter a valid SSN')
      .test('not-invalid-ssn', 'SSN already exists on application.', function (value) {
        // If new value is the same as the initial value, skip the validation
        if (ssnUnmaskedCleaned == value) return true
        if (!value || !applicationSsns) return true
        return !applicationSsns?.['ssns'].includes(value)
      }),
  })
